import { GetCurrentPatients } from "@/components/graphql/types/getCurrentPatient";
import { GetPatientsPayload } from "@/redux/slice/auth/types/GetPatientsPayload";
import { GET_CURRENT_PATIENTS } from "@/components/graphql/profiles";

export default async function getCurrentPatientsApi(getPatientsPayload: GetPatientsPayload) {
  const { apolloClient } = getPatientsPayload;

  return await apolloClient.query<GetCurrentPatients>({
    query: GET_CURRENT_PATIENTS,
    fetchPolicy: "no-cache",
  });
}
